"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RuEndingEnum = void 0;
const i18next_1 = __importDefault(require("i18next"));
function getOrdinalEn(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
var RuEndingEnum;
(function (RuEndingEnum) {
  RuEndingEnum["FEMALE"] = "-\u044F";
  RuEndingEnum["MALE"] = "-\u0439";
})(RuEndingEnum || (exports.RuEndingEnum = RuEndingEnum = {}));
function getOrdinalRu(n, ending = RuEndingEnum.FEMALE) {
  return `${n}${ending}`;
}
function getOrdinal(n, options) {
  const {
    ruEnding
  } = options !== null && options !== void 0 ? options : {};
  const lang = i18next_1.default.language;
  switch (lang) {
    case 'en':
      return getOrdinalEn(n);
    case 'ru':
      return getOrdinalRu(n, ruEnding);
    default:
      return n.toString();
  }
}
exports.default = getOrdinal;